export interface TuitionFeeItem {
  level: string;
  averageRate: string;
  group: 'primary' | 'secondary' | 'pre-university';
}

export const tuitionFeeData: TuitionFeeItem[] = [
  { level: 'Standard 1 - Standard 3', averageRate: 'RM 35 - RM 50', group: 'primary' },
  { level: 'Standard 4 - Standard 6', averageRate: 'RM 40 - RM 55', group: 'primary' },
  { level: 'Form 1 - Form 3', averageRate: 'RM 45 - RM 60', group: 'secondary' },
  { level: 'Form 4 - Form 5', averageRate: 'RM 50 - RM 70', group: 'secondary' },
  { level: 'Form 6', averageRate: 'RM 60 - RM 85', group: 'pre-university' },
];
